export default __webpack_public_path__ + "static/media/breathe1.9f132ac3.gif";